import Vue from 'vue';
import Vuex from 'vuex';
import createPersisitedState from 'vuex-persistedstate';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  loggedIn: false,
  loginError: null,
  currentDirectory: null,
  directoryStructure: null,
  directoryPermissions: null,
  directoryFiles: null,
  relatedFiles: []
};

export default new Vuex.Store({
  actions,
  mutations,
  state
  // plugins: [createPersisitedState()]
});
